import {
    useEffect,
    useState,
} from 'react';

// FNP-815 / FNP-1191: the search input (TableSearchForm, inside ZonesTable) and
// the list hook that filters on the keyword live in DIFFERENT components. A
// local useState would give each its own copy of the keyword and search would
// silently do nothing. Module-scoped store; every caller subscribes.
//
// Do not replace with a local useState.
let globalKeyword = '';
const keywordListeners: Set<(keyword: string) => void> = new Set();

const notifyKeywordChange = (keyword: string) => {
    globalKeyword = keyword;
    keywordListeners.forEach(listener => listener(keyword));
};

// Test-only reset. The store outlives a component tree by design, which means it
// also outlives a test case — without this, a keyword set in one test leaks into
// the next.
export const resetZonesSearch = () => {
    globalKeyword = '';
    keywordListeners.clear();
};

export const useZonesSearch = () => {
    const [keyword, setKeyword] = useState<string>(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => {
            setKeyword(newKeyword);
        };
        keywordListeners.add(listener);
        // A consumer mounting after the keyword was set must not start from ''.
        setKeyword(globalKeyword);
        return () => {
            keywordListeners.delete(listener);
        };
    }, []);

    const handleFilterByKeyword = (newKeyword: string) => {
        notifyKeywordChange(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};
